import axios from "axios";
import { pickUrlMooda } from "./util/moodaUrl";

export const UPLOAD_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://mooda-space.nyc3.digitaloceanspaces.com/"
    :  // dev: a API local sobe mídia pro bucket mooda-poc-space (com prefixo
      // __development), então o admin precisa ler do mesmo bucket.
      "https://mooda-space.nyc3.cdn.digitaloceanspaces.com/";


const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.mooda.app.br/api"
    : "http://localhost:8080/api/";

// TODO: Definir quem pode usar essa API??? sem companyId
const BASE_URLST =
  process.env.NODE_ENV === "production"
    ? "https://api.mooda.app.br/api"
    : "http://localhost:8080/api/";

export const nameMooda = "Mooda";
export const slugMooda = "mooda";
export const urlSiteMooda = "http://site.mooda.app.br/";
export const urlMooda =
  process.env.NODE_ENV === "production"
    ? "https://mobile.mooda.app.br/"
    : "https://pocmobile.mooda.app.br/";
// configUI.isRetail === "true" → varejo em https://{slug}.mooda.com.br/
// (só em production; fora dela não há domínio de varejo)
export const domainMoodaRetail =
  process.env.NODE_ENV === "production" ? "mooda.com.br" : null;
// base já com o slug; concatene a página: resolveUrlMooda(isRetail, slug) + "home"
export const resolveUrlMooda = (isRetail, slug) =>
  pickUrlMooda(isRetail, slug, urlMooda, domainMoodaRetail);
export const urlAdminMooda =
  process.env.NODE_ENV === "production"
    ? "https://admin.mooda.app.br/"
    : "https://pocadmin.mooda.app.br/";
export const whatsAppCall = "https://wa.me//55";

//const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjIsImlzQWRtaW4iOnRydWUsImlhdCI6MTY4NjIyOTc2NiwiZXhwIjoxNjg2NDg4OTY2fQ.stlcRCF6F58QYS6Ri1ta3utUPwhQTX4L4z3mdBEy_Ug"
export const publicRequest = axios.create({
  baseURL: BASE_URL,
});
export const publicRequestSt = axios.create({
  baseURL: BASE_URLST,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
  //headers: { token: `Bearer ${TOKEN}` },
});

userRequest.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("persist:root"))?.user;
    const currentUser = user && JSON.parse(user).currentUser;
    const TOKEN = currentUser?.accessToken;

    config.headers.token = `Bearer ${TOKEN}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
userRequest.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      window.localStorage.clear();

      var split = window.location.pathname.toString().split("/");
      var newUrl = window.location.origin + "/" + split[1] + "/login";
      window.location.href = newUrl;

      return Promise.reject("Unauthorized");
    }
    if (error.response && error.response.status === 406) {
      localStorage.clear();
      window.location.href = window.location.pathname;
    }
    // Handle other errors here
    return Promise.reject(error);
  },
);

export const generateFileUrl = (image) => {
  if (image && image.includes("http")) {
    return image;
  }

  return `${UPLOAD_BASE_URL}${image}`;
};

// A	mobile.mooda.app.br	199.36.158.100
// A	admin.mooda.app.br	199.36.158.100
// "injectQAConfig":"cp src/requestMethods.QA.js src/requestMethods.js",
